var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDownCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.00004 8.66699L9.33337 8.66699L7.00004 11.0003L7.94671 11.947L11.8934 8.00033L7.94671 4.05366L7.00004 5.00033L9.33337 7.33366L4.00004 7.33366L4.00004 8.66699ZM14.6667 8.00033C14.6667 8.8758 14.4943 9.74271 14.1592 10.5515C13.8242 11.3604 13.3331 12.0953 12.7141 12.7144C11.4638 13.9646 9.76815 14.667 8.00004 14.667C6.23193 14.667 4.53624 13.9646 3.286 12.7144C2.03575 11.4641 1.33337 9.76844 1.33337 8.00033C1.33337 7.12485 1.50581 6.25794 1.84084 5.4491C2.17587 4.64027 2.66694 3.90534 3.28599 3.28628C3.90505 2.66722 4.63998 2.17616 5.44882 1.84113C6.25765 1.5061 7.12456 1.33366 8.00004 1.33366C9.76815 1.33366 11.4638 2.03604 12.7141 3.28628C13.9643 4.53652 14.6667 6.23222 14.6667 8.00033Z",
    fill: "#481AA3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownCircle);
export default __webpack_public_path__ + "static/media/arrow-down-circle.754699ccde3d8d74e7b866730b8686df.svg";
export { ForwardRef as ReactComponent };